import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from 'react-i18next';
import { Alert, Box, TextField } from '@mui/material';
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useInput } from '../../lib';

export default function NewTagModal({ userId, setMomentCreatedMessage, onTagCreated}) {
  const [open, setOpen] = React.useState(false);
  const [newTagName, handleNewTagName, setNewTagName] = useInput("")
  const [createTagError, setCreateTagError] = useState(null)

  const { t } = useTranslation();


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCreateTagError(null)
  };


  const handleCreateTag = async () => {

    try {
      const createdTag = await addDoc(collection(db, 'users', userId, 'moments'), {
        name: newTagName,
      });
      setOpen(false);
      setMomentCreatedMessage(newTagName)
      onTagCreated(createdTag.id)
      setCreateTagError(null)
    } catch (error) {
      console.log("An error occurred trying to create, please try again", error)
      setCreateTagError(t('newOutfit.createTagError'))
    }
  }

  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClickOpen}
        sx={{ margin: 2, fontSize: '0.6rem' }}
      >
        {t('newOutfit.createTag')}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{ display: 'flex', alignItems: 'center' }}>
          <DialogContentText id="alert-dialog-description">
            <Box
              component="form"
              noValidate
              autoComplete="off"
              onChange={handleNewTagName}
              value={newTagName}
            >
              <TextField id="outlined-basic" label="Create Tag" variant="outlined" />
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" autoFocus color="secondary">
            {t('close')}
          </Button>
          <Button onClick={handleCreateTag} variant="contained" autoFocus color="primary">
            {t('save')}
          </Button>
        </DialogActions>
        {createTagError != null &&
          <Alert severity="error" sx={{ mb: 2 }}>{createTagError}</Alert>
        }
      </Dialog>
    </Box>
  );
}
